import React, { useMemo, useRef } from 'react'
import { ItemContent } from './item-content'
import { ItemChoice } from './item-choice'
import { IconCheck, IconCopy } from '../../../../../../../../shared/icon/icon'
import { useCopy } from '../../../../../../../../shared/clipboard/clipboard'
import { ItemCitations } from './item-citation'
import { ItemCreated } from './item-created'
import { ItemModel } from './item-model'

export const Item = ({ item }) => {
  const choice = useMemo(() => (item.result.choices.length ? item.result.choices[0] : 'NO CHOICE RETURNED'), [item])

  // Copied inside the click (shared/clipboard), so Safari allows it; the
  // check only after a real copy, otherwise the answer is selected.
  const copy = useCopy()
  const answer = useRef(null)
  const handleCopy = () => copy.copy(choice.message.content, answer)

  return (
    <React.Fragment>
      <div className="d-flex flex-column">
        <div className="m-2">
          <ItemContent content={item.content} />
        </div>
        <div className="m-2" ref={answer}>
          <ItemChoice choice={choice} />
        </div>
        <div className="m-2 d-flex">
          <div className="flex-fill d-flex">
            <div className="mx-1" style={{ cursor: 'pointer' }} onClick={handleCopy}>
              {copy.copied ? <IconCheck /> : <IconCopy />}
            </div>
            {copy.manual && <span className="mx-1 small text-muted" role="status">{copy.hint}</span>}
            <div className="mx-1">
              <ItemCitations citations={item.result.citations} />
            </div>
          </div>
          <ItemModel result={item.result} />
          <ItemCreated value={item.result.created} />
        </div>
        <div className="border-bottom border-2 m-3" />
      </div>
    </React.Fragment>
  )
}
